module.exports = __webpack_public_path__ + "img/Principle of Economics.021b80bb.svg";